interface IApiConfig {
  host: string;
  paths: {
    graphql: string;
  };
}

interface IAuthConfig {
  host: string;
  response_type: string;
  redirect_uri: string;
  state: string;
  code_challenge: string;
  code_challenge_method: string;
  code_verifier: string;
  scope: string;
  gettoken: string;
  introspect: string;
  paths: {
    authorise: string;
    token: string;
  };
  clientId: string;
  groupIds: string[];
  regionsMemberGroupMap: {
    OM02: string;
    PH01: string;
    PK01: string;
    MARINE: string;
  };
}

interface IEnv {
  frontend: {
    host: string;
  };
  api: IApiConfig;
  auth: IAuthConfig;
  ga?: {
    trackingId: string;
  };
}

interface IEnvs {
  cypress: IEnv;
  local: IEnv;
  dev: IEnv;
  staging: IEnv;
  preprod: IEnv;
  prod: IEnv;
}

const envs: IEnvs = {
  cypress: {
    api: {
      host: 'http://localhost:4000',
      paths: {
        graphql: '/graphql',
      },
    },
    auth: {
      groupIds: [
        'fgo-gsuk-lonsc-zz-love-agilehub-dev-lubes-gs',
        'fgo-gsuk-lonsc-zz-love-agilehub-dev-aviation-gs',
        'fgo-gsuk-lonsc-zz-love-agilehub-dev-retail-fuels-gs',
      ],
      regionsMemberGroupMap: {
        OM02: '',
        PH01: '',
        PK01: '',
        MARINE: '',
      },
      clientId: 'ba2dcf09-181c-43c3-972c-bf0f511175eb',
      host: 'http://localhost:5000',
      response_type: 'code',
      redirect_uri: 'http://localhost:3001/auth/callback',
      state: 'STQAQmfrcU',
      gettoken: 'https://sso-dev.shell.com/as/token.oauth2',
      introspect: 'https://sso-dev.shell.com/as/introspect.oauth2',
      code_challenge: 'owmoFRSqLoaiv6kTgHg7iAuyqlKayroH3vAImOlVGng',
      code_challenge_method: 'S256',
      code_verifier:
        'LmwAyWqkG9n1-KAsANKMCx83CIVOuUNUdDektOcHXHREcqRYnPeEh0y_lSF9k3IofBvtkLKJ1E7hX50a0rKbPdawaZo5qZiTYftsnKkQknXbARrqvlHKpqq7YJQWFH7-',
      scope: 'openid',
      paths: {
        authorise: '/directory/authorize',
        token: '/directory/token',
      },
    },
    frontend: {
      host: 'http://localhost:3001',
    },
  },
  dev: {
    api: {
      host: 'https://api-cove.dev.aze.shell.io',
      paths: {
        graphql: '/graphql',
      },
    },
    auth: {
      groupIds: [
        'fgo-gsuk-lonsc-zz-love-agilehub-dev-lubes-gs',
        'fgo-gsuk-lonsc-zz-love-agilehub-dev-aviation-gs',
        'fgo-gsuk-lonsc-zz-love-agilehub-dev-retail-fuels-gs',
      ],
      regionsMemberGroupMap: {
        OM02: 'fgo-gsuk-lonsc-zz-love-agilehub-dev-oman-gs',
        PH01: 'fgo-gsuk-lonsc-zz-love-agilehub-dev-philippines-gs',
        PK01: 'fgo-gsuk-lonsc-zz-love-agilehub-dev-pakistan-gs',
        MARINE: 'fgo-gsuk-lonsc-zz-love-agilehub-dev-marine-gs',
      },
      clientId: '0306e66b21f4348a16b85bb8823480b4',
      host: 'https://sso-dev.shell.com/as/authorization.oauth2',
      response_type: 'code',
      redirect_uri: 'https://dev.love.shell.com/auth/callback',
      state: 'NavZZFehPp',
      gettoken: 'https://sso-dev.shell.com/as/token.oauth2',
      introspect: 'https://sso-dev.shell.com/as/introspect.oauth2',
      code_challenge: 'owmoFRSqLoaiv6kTgHg7iAuyqlKayroH3vAImOlVGng',
      code_challenge_method: 'S256',
      code_verifier:
        'LmwAyWqkG9n1-KAsANKMCx83CIVOuUNUdDektOcHXHREcqRYnPeEh0y_lSF9k3IofBvtkLKJ1E7hX50a0rKbPdawaZo5qZiTYftsnKkQknXbARrqvlHKpqq7YJQWFH7-',
      scope: 'openid',
      paths: {
        authorise: '/directory/authorize',
        token: '/directory/token',
      },
    },
    frontend: {
      host: 'https://dev.love.shell.com',
    },
    ga: {
      trackingId: 'UA-146502431-6',
    },
  },
  local: {
    api: {
      host: 'http://localhost:8080',
      paths: {
        graphql: '/graphql',
      },
    },
    auth: {
      groupIds: [
        'fgo-gsuk-lonsc-zz-love-agilehub-dev-lubes-gs',
        'fgo-gsuk-lonsc-zz-love-agilehub-dev-aviation-gs',
        'fgo-gsuk-lonsc-zz-love-agilehub-dev-retail-fuels-gs',
      ],
      regionsMemberGroupMap: {
        OM02: 'fgo-gsuk-lonsc-zz-love-agilehub-dev-oman-gs',
        PH01: 'fgo-gsuk-lonsc-zz-love-agilehub-dev-philippines-gs',
        PK01: 'fgo-gsuk-lonsc-zz-love-agilehub-dev-pakistan-gs',
        MARINE: 'fgo-gsuk-lonsc-zz-love-agilehub-dev-marine-gs',
      },
      clientId: '0306e66b21f4348a16b85bb8823480b4',
      host: 'https://sso-dev.shell.com/as/authorization.oauth2',
      response_type: 'code',
      redirect_uri: 'https://localhost:3000/auth/callback',
      state: 'UpazmhcEBh',
      gettoken: 'https://sso-dev.shell.com/as/token.oauth2',
      introspect: 'https://sso-dev.shell.com/as/introspect.oauth2',
      code_challenge: 'uoKeHmBVPz47RRgwgg-evKFx7-Jq0YSY7aV9RmoHGmA',
      code_challenge_method: 'S256',
      code_verifier:
        'N9THT_Y9hCBqSUDKCJMG-o7dOVSwbvONGA3hErx4mKaOBHhm2UU5T5bc5MVnUWPAmhtmSxOSsiz6eZfGs7S_jL1Ru0bP_q7niDK7Au7MGlficIgC2wkrQoAVlkUZoUha',
      scope: 'openid',
      paths: {
        authorise: '/directory/authorize',
        token: '/directory/token',
      },
    },
    frontend: {
      host: 'http://localhost:3000',
    },
  },
  preprod: {
    api: {
      host: 'https://api-cove.preprod.aze.shell.io',
      paths: {
        graphql: '/graphql',
      },
    },
    auth: {
      groupIds: [
        'fgo-gsuk-lonsc-zz-love-agilehub-test-lubes-gs',
        'fgo-gsuk-lonsc-zz-love-agilehub-test-aviation-gs',
        'fgo-gsuk-lonsc-zz-love-agilehub-test-retail-fuels-gs',
      ],
      regionsMemberGroupMap: {
        OM02: 'fgo-gsuk-lonsc-zz-love-agilehub-test-oman-gs',
        PH01: 'fgo-gsuk-lonsc-zz-love-agilehub-test-philippines-gs',
        PK01: 'fgo-gsuk-lonsc-zz-love-agilehub-test-pakistan-gs',
        MARINE: 'fgo-gsuk-lonsc-zz-love-agilehub-test-marine-gs',
      },
      clientId: 'd2ec53a71f4f3bb2a0b442c633bdcc5d',
      host: 'https://sso-uat.shell.com/as/authorization.oauth2',
      response_type: 'code',
      redirect_uri: 'https://preprod.love.shell.com/auth/callback',
      state: 'DZHsxPuKpu',
      code_challenge: 'AdsH_brOuSzKgPcXv7S-Wb-vqCW_Vj1orXIw9pILuTI',
      code_challenge_method: 'S256',
      code_verifier:
        'rnX9dsySUp9F0SC63I8KJIUmsgEClE1t6LpvfwPgXVCHtPp3lqRLS0fhbkW-K5UrKoBdrDxR8CaDA9mzujuBzj_ItoFiDkdkXH7oYGS1uxIV7k1I0xYB-3EjSuqEyE66',
      gettoken: 'https://sso-uat.shell.com/as/token.oauth2',
      introspect: 'https://sso-uat.shell.com/as/introspect.oauth2',
      scope: 'openid',
      paths: {
        authorise: '/directory/authorize',
        token: '/directory/token',
      },
    },
    frontend: {
      host: 'https://preprod.love.shell.com',
    },
    ga: {
      trackingId: 'UA-146502431-7',
    },
  },
  prod: {
    api: {
      host: 'https://api-cove.prod.aze.shell.io',
      paths: {
        graphql: '/graphql',
      },
    },
    auth: {
      groupIds: [
        'fgo-gsuk-lonsc-zz-love-agilehub-prod-lubes-gs',
        'fgo-gsuk-lonsc-zz-love-agilehub-prod-aviation-gs',
        'fgo-gsuk-lonsc-zz-love-agilehub-prod-retail-fuels-gs',
      ],
      regionsMemberGroupMap: {
        OM02: 'fgo-gsuk-lonsc-zz-love-agilehub-prod-oman-gs',
        PH01: 'fgo-gsuk-lonsc-zz-love-agilehub-prod-philippines-gs',
        PK01: 'fgo-gsuk-lonsc-zz-love-agilehub-prod-pakistan-gs',
        MARINE: 'fgo-gsuk-lonsc-zz-love-agilehub-prod-marine-gs',
      },
      clientId: '1594f28489254e5a0156d86ecafce345',
      host: 'https://sso.shell.com/as/authorization.oauth2',
      response_type: 'code',
      redirect_uri: 'https://love.shell.com/auth/callback',
      state: 'bSJkFfSnmk',
      gettoken: 'https://sso.shell.com/as/token.oauth2',
      introspect: 'https://sso.shell.com/as/introspect.oauth2',
      code_challenge: '80ZaDJkgWIVRFXbzqpxXDFXQrtZz-yaCJpbWiJ4GI2M',
      code_challenge_method: 'S256',
      code_verifier:
        'NGruNN7kUfWAtaFnPszxCtlA94bKk36wV8VsY4Yv1Nd9LOPbMB2btgyACZDO-NCSlbaK411emgGZxaKrd5fy8P1gzfCGnfBN1n0hmJ1KJ7L-gsAVkUa4SUTkU_x5ywuC',
      scope: 'openid',
      paths: {
        authorise: '/directory/authorize',
        token: '/directory/token',
      },
    },
    frontend: {
      host: 'https://love.shell.com',
    },
    ga: {
      trackingId: 'UA-146502431-8',
    },
  },
  staging: {
    api: {
      host: 'https://api-cove.staging.aze.shell.io',
      paths: {
        graphql: '/graphql',
      },
    },
    auth: {
      groupIds: [
        'fgo-gsuk-lonsc-zz-love-agilehub-test-lubes-gs',
        'fgo-gsuk-lonsc-zz-love-agilehub-test-aviation-gs',
        'fgo-gsuk-lonsc-zz-love-agilehub-test-retail-fuels-gs',
      ],
      regionsMemberGroupMap: {
        OM02: 'fgo-gsuk-lonsc-zz-love-agilehub-test-oman-gs',
        PH01: 'fgo-gsuk-lonsc-zz-love-agilehub-test-philippines-gs',
        PK01: 'fgo-gsuk-lonsc-zz-love-agilehub-test-pakistan-gs',
        MARINE: 'fgo-gsuk-lonsc-zz-love-agilehub-test-marine-gs',
      },
      clientId: 'd2ec53a71f4f3bb2a0b442c633bdcc5d',
      host: 'https://sso-uat.shell.com/as/authorization.oauth2',
      response_type: 'code',
      redirect_uri: 'https://test.love.shell.com/auth/callback',
      state: 'DZHsxPuKpu',
      code_challenge: 'RRQWiRXvTBZWq1AwGk67XUq-ssRzQii7jVjhszP_Tgg',
      code_challenge_method: 'S256',
      code_verifier:
        '3uvLVWMF03VQmSatIFsu97xt944WHad7KQAHHHmoWTI75gNOseDYEXqoK3BjWpmkgnYYqn5yQw5jND0RUCvcPGZq-HgA1-7rnsIVCTchVeCTpMUcA2BsIQDgZ9nU-Pr0',
      gettoken: 'https://sso-uat.shell.com/as/token.oauth2',
      introspect: 'https://sso-uat.shell.com/as/introspect.oauth2',
      scope: 'openid',
      paths: {
        authorise: '/directory/authorize',
        token: '/directory/token',
      },
    },
    frontend: {
      host: 'https://test.love.shell.com',
    },
    ga: {
      trackingId: 'UA-146502431-7',
    },
  },
};

// https://stackoverflow.com/a/56458070/7396096
declare global {
  // tslint:disable-next-line:interface-name
  interface Window {
    REACT_APP_ENV: string;
  }
}
const REACT_APP_ENV = window.REACT_APP_ENV || 'local';
// @ts-ignore
export default envs[REACT_APP_ENV];
